<template>
    <div class="popup-wrapper">
        <div class="popup-box">
            <div class="top clearfix">
                <span class="text">提示</span>
                <span class="close pointer" @click="cancel"></span>
            </div>
            <div class="content">
                您即将进入辟谣联盟成员“封面新闻”官网提交辟谣线索，我们将尽快处理
            </div>
            <div class="bottom clearfix">
                <div class="checkBox-wrapper pointer" @click="check">
                    <div class="checkBox" :class="{'check': checked}"></div>
                    不再提示
                </div>
                <div class="btn-group">
                    <div class="cancel pointer" @click="cancel">取消</div>
                    <div class="confirm pointer" @click="confirm">确定</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
    name: 'PopUp',
    data() {
        return {
            checked: false, // 选中不再提示
        }
    },
    methods: {
        ...mapMutations(['setShowPop']),
        check() {
            this.checked = !this.checked;
        },
        cancel() {
            if(this.checked) {
                localStorage.setItem('notShowPiyaoPop', 'true')
            }
            this.setShowPop(false);
        },
        confirm() {
            if(this.checked) {
                localStorage.setItem('notShowPiyaoPop', 'true')
            }
            this.setShowPop(false);
            window.open('http://www.thecover.cn/cloudHelp');
        }
    }
}
</script>
<style lang="less" scoped>
.popup-wrapper {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    animation: show-pop .2s;
    z-index: 9999;
    .popup-box {
        width: 30rem;
        padding: 1rem 0;
        box-sizing: border-box;        
        background: #FFFFFF;
        box-shadow: 0px 0.75rem 3rem 1rem rgba(0, 0, 0, 0.03), 0px 0.5625rem 1.75rem 0px rgba(0, 0, 0, 0.05), 0px 0.375rem 1rem -0.5rem rgba(0, 0, 0, 0.08);
        border-radius: 0.125rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .top {
            padding: 0 1.5rem;
            font-size: 1rem;
            color: rgba(0, 0, 0, 0.85);
            margin-bottom: 1rem;
            .text {
                float: left;
            }
            .close {
                float: right;
                width: 1rem;
                height: 1rem;
                background: url('./../assets/img/popup_close.png') center no-repeat;
                background-size: cover;
            }
        }
        .content {
            padding: 1.375rem 1.5rem;
            color: rgba(0, 0, 0, 0.65);
            font-size: 0.875rem;
            line-height: 1.375rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            border-top: 1px solid rgba(0, 0, 0, 0.06);
        }
        .bottom {
            padding: 0 1.5rem;
            padding-top: 0.625rem;
            .checkBox-wrapper {
                float: left;
                height: 2.125rem;
                line-height: 2.125rem;
                font-size: 0.875rem;
                color: #666666;
                .checkBox {
                    display: inline-block;
                    width: 0.9375rem;
                    height: 0.9375rem;
                    border-radius: 50%;
                    border: 1px solid #666666;
                    position: relative;
                    top: 0.25rem;
                }
                .check {
                    border: none;
                    background: #1890FF;
                    border: 1px solid #1890FF;
                }
            }
            .btn-group {
                float: right;
                div {
                    width: 4.0625rem;
                    height: 2rem;
                    line-height: 2rem;
                    background: #FFFFFF;
                    border-radius: 0.125rem;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    text-align: center;
                    display: inline-block;
                }
                .cancel {
                    color: rgba(0, 0, 0, 0.65);
                }
                .confirm {
                    color: #fff;
                    background: #1890FF;
                    border: none;
                    margin-left: 0.5rem;
                }
            }
        }
    }
}
@keyframes show-pop {
    from {
        transform: scale(0);
    }
    to {
        transform: scale(1);
    }
}
</style>